<template>
    <svg
        id="LogoSvg"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 1004.1 166"
        style="enable-background: new 0 0 1004.1 166"
        xml:space="preserve"
        height="40"
        width="200"
    >
        <g>
            <path
                class="st0"
                d="M181,22.7c3.4-2.6,8.8-4.9,16.3-4.9c10.5,0,17.8,4.4,17.8,17.8V65h-6.4v-3.7c-4,2.7-9.1,4.3-14.4,4.3
		c-9.2,0-16.6-4.7-16.6-14.8c0-10.2,7.5-15.5,17.9-15.5c4.3,0,9,1,12.8,2.8V36c0-8.9-4.6-11.7-11.7-11.7c-8.3,0.1-15.6,5.8-15.6,5.8
		L181,22.7z M208.3,56.6V42.8c-3.4-1.5-7.7-2.2-11.4-2.2c-7.3,0-12.8,3.2-12.8,9.9c0,6.5,5.2,9.4,11.5,9.4
		C200,59.9,204.6,58.8,208.3,56.6z"
            />
            <path
                class="st0"
                d="M253.7,6c0,2.6-1.8,4.4-4.1,4.4s-4-1.8-4-4.4c0-2.6,1.7-4.3,4-4.3S253.7,3.4,253.7,6z M253.1,18.9V65h-6.9
		V18.9H253.1z"
            />
            <path
                class="st0"
                d="M303.5,24.3c-5.3,0-9.7,2.2-12.6,9V65h-6.9V18.9h6.4v6.4c3.4-4.8,8.1-7.6,14.2-7.6c4.1,0,6.7,1.2,8.3,2.7
		l0,7.8C312.9,28.3,310.1,24.2,303.5,24.3z"
            />
            <path
                class="st0"
                d="M440.1,42c0,15.8-8,24.1-19.3,24.1c-11.4,0-19.3-8.4-19.3-24.1c0-15.8,8-24.2,19.3-24.2
		C432,17.8,440.1,26.1,440.1,42z M408,42c0,11.7,5.2,17.8,12.8,17.8c7.6,0,12.8-6.1,12.8-17.8s-5.3-17.8-12.8-17.8
		C413.3,24.2,408,30.3,408,42z"
            />
            <path
                class="st0"
                d="M521,18.9V6.3l6.9-2.3v14.9h12.3v5.7h-12.3v27.9c0,4.1,2.1,6.2,5.9,6.2c2.2,0,4.5-0.7,6.7-2.9l0,6.4
		c0,0-3.7,3.2-9.5,3.2c-5.5,0-9.9-3.7-9.9-11.5V24.6h-5.3v-5.7H521z"
            />
            <path
                class="st0"
                d="M484.1,24.3c-5.3,0-9.7,2.2-12.6,9V65h-6.9V18.9h6.4v6.4c3.4-4.8,8.1-7.6,14.2-7.6c4.1,0,6.7,1.2,8.3,2.7
		l0,7.8C493.5,28.3,490.6,24.2,484.1,24.3z"
            />
            <path
                class="st0"
                d="M344.6,18.9v6.8c3.1-4.5,7.8-7.9,14.7-7.9c13,0,17.8,12.2,17.8,24.1c0,12.1-4.8,24.2-17.8,24.2
		c-6.5,0-11.2-3.1-14.3-7.2V81l-6.9,2.3V18.9H344.6z M345,32.6v18.7c2.6,4.8,6.5,8.4,12.7,8.4c9.6,0,12.8-8.6,12.8-17.9
		c0-9.3-3.2-17.9-12.8-17.9C351.5,24.1,347.6,27.5,345,32.6z"
            />
            <path
                class="st0"
                d="M521,18.9V6.3l6.9-2.3v14.9h12.3v5.7h-12.3v27.9c0,4.1,2.1,6.2,5.9,6.2c2.2,0,4.5-0.7,6.7-2.9l0,6.4
		c0,0-3.7,3.2-9.5,3.2c-5.5,0-9.9-3.7-9.9-11.5V24.6h-5.3v-5.7H521z"
            />
        </g>
        <g>
            <path
                class="st0"
                d="M682.5,22.7c3.4-2.6,8.8-4.9,16.3-4.9c10.5,0,17.8,4.4,17.8,17.8V65h-6.4v-3.7c-4,2.7-9.1,4.3-14.4,4.3
		c-9.2,0-16.6-4.7-16.6-14.8c0-10.2,7.5-15.5,17.9-15.5c4.3,0,9,1,12.8,2.8V36c0-8.9-4.6-11.7-11.7-11.7c-5.2,0-9.2,1.4-12.8,3.9
		L682.5,22.7z M709.7,56.6V42.8c-3.4-1.5-7.7-2.2-11.4-2.2c-7.3,0-12.8,3.2-12.8,9.9c0,6.5,5.2,9.4,11.5,9.4
		C701.4,59.9,706,58.8,709.7,56.6z"
            />
            <path
                class="st0"
                d="M836,18.9l-16.9,18.5L838.6,65H831l-16.2-22.9l-8.7,9.6V65h-6.9V2.3l6.9-2.3v43.6l22.4-24.6H836z"
            />
            <path
                class="st0"
                d="M870.8,6c0,2.6-1.8,4.4-4.1,4.4s-4-1.8-4-4.4c0-2.6,1.7-4.3,4-4.3S870.8,3.4,870.8,6z M870.2,18.9V65h-6.9
		V18.9H870.2z"
            />
            <path
                class="st0"
                d="M907.9,18.9v6.6c3.5-5.1,8.7-7.7,15.4-7.7c9.4,0,15.9,5.2,15.9,18V65h-6.9V36.4c0-8.7-4.4-12.1-11.1-12.1
		c-5.7,0-10.2,2.5-12.9,9.1V65h-6.9V18.9H907.9z"
            />
            <path
                class="st0"
                d="M1002.8,18.9v37.5c0,6-1,10.8-3,14.6c-3.6,6.6-10,9.5-15.6,10.9c-7,1.7-14-0.7-14-0.7l-0.2-6.8
		c0,0,10.5,4.2,18.6-1.4c5.5-3.2,7.9-7.9,7.9-15.1v-1.7c-3.1,4-7.8,7.1-14.6,7.1c-13.1,0-17.8-11.8-17.8-22.9
		c0-11.1,4.7-22.8,17.7-22.8c6.8,0,11.6,3.2,14.7,7.3v-6.2H1002.8z M996.3,48.9V32.3c-2.6-4.8-6.6-8.3-12.9-8.3
		c-9.9,0-12.9,8.2-12.9,16.6s3.1,16.7,12.8,16.7C989.7,57.4,993.7,53.8,996.3,48.9z"
            />
            <path
                class="st0"
                d="M765,24.3c-5.3,0-9.7,2.2-12.6,9v31.8h-6.9V18.9h6.4v6.4c3.4-4.8,8.1-7.6,14.2-7.6c4.1,0,6.7,1.2,8.3,2.7
		l0,7.8C774.3,28.4,771.5,24.3,765,24.3z"
            />
            <path
                class="st0"
                d="M623.4,18.9v6.8c3.1-4.5,7.8-7.9,14.7-7.9c13,0,17.8,12.2,17.8,24.1c0,12.1-4.8,24.2-17.8,24.2
		c-6.5,0-11.2-3.1-14.3-7.2V81l-6.9,2.3V18.9H623.4z M623.9,32.6v18.7c2.6,4.8,6.5,8.4,12.7,8.4c9.6,0,12.8-8.6,12.8-17.9
		c0-9.3-3.2-17.9-12.8-17.9C630.3,24.1,626.4,27.5,623.9,32.6z"
            />
            <path
                class="st0"
                d="M1002.8,18.9v37.5c0,6-1,10.8-3,14.6c-3.6,6.6-10,9.5-15.6,10.9c-7,1.7-14-0.7-14-0.7l-0.2-6.8
		c0,0,10.5,4.2,18.6-1.4c5.5-3.2,7.9-7.9,7.9-15.1v-1.7c-3.1,4-7.8,7.1-14.6,7.1c-13.1,0-17.8-11.8-17.8-22.9
		c0-11.1,4.7-22.8,17.7-22.8c6.8,0,11.6,3.2,14.7,7.3v-6.2H1002.8z M996.3,48.9V32.3c-2.6-4.8-6.6-8.3-12.9-8.3
		c-9.9,0-12.9,8.2-12.9,16.6s3.1,16.7,12.8,16.7C989.7,57.4,993.7,53.8,996.3,48.9z"
            />
        </g>
        <g>
            <path
                class="st0"
                d="M207.4,93.4c15.8,0,26.4,7.6,26.4,22.8c0,10.4-4.9,17.2-13.2,20.4l16.8,28.1H218l-14.6-25.9h-9.1v25.9h-17.1
		V93.4H207.4z M194.2,124.3h13.5c5.8,0,9.8-2.4,9.8-7.8c0-5.4-4-7.6-9.8-7.6h-13.5V124.3z"
            />
            <path class="st0" d="M300.6,93.4v15.9h-30.8v11.4h21.3v15.2h-21.3v12.9h31.5v15.9h-48.6V93.4H300.6z" />
            <path
                class="st0"
                d="M326.8,142.2c5.2,5,11.3,8.3,20.3,8.3c8.7,0,12.6-3,12.6-7.6c0-4.1-3-5.4-6.4-6.4c-4.6-1.3-13.1-3.1-20.2-5.9
		c-8.3-3.3-13.9-7.9-13.9-17.2c0-12.3,9.7-20.8,27.3-20.8c14.5,0,23.4,5.9,27.9,11.3l-12.1,10.4c-4.3-4.1-9.6-6.5-17-6.5
		c-5.8,0-9.7,1.4-9.7,4.8c0,2.9,2.7,4.1,5.4,5c5.8,2,14.2,3.2,20.7,5.7c7.8,3,14.5,8.3,14.5,19.4c0,14.9-12.3,22.7-30.3,22.7
		c-15.3,0-26-5.7-31.9-12.9L326.8,142.2z"
            />
            <path class="st0" d="M440.9,93.4v15.9h-30.8v11.4h21.3v15.2h-21.3v12.9h31.5v15.9H393V93.4H440.9z" />
            <path
                class="st0"
                d="M490,93.4c15.8,0,26.4,7.6,26.4,22.8c0,10.4-4.9,17.2-13.2,20.4l16.8,28.1h-19.4L486,138.8h-9.1v25.9h-17.1
		V93.4H490z M476.8,124.3h13.5c5.8,0,9.8-2.4,9.8-7.8c0-5.4-4-7.6-9.8-7.6h-13.5V124.3z"
            />
            <path class="st0" d="M546.6,93.4l16.5,48.9l16.4-48.9H598l-25.9,71.3h-18.2L528,93.4H546.6z" />
            <path
                class="st0"
                d="M643.1,93.4l26,71.3h-18.1l-4.2-12.6h-25.3l-4.1,12.6h-18.1l25.7-71.3H643.1z M626.4,137h15.1l-7.6-22.6
		L626.4,137z"
            />
            <path class="st0" d="M729.8,93.4v15.9h-19.9v55.4h-17.1v-55.4h-20.1V93.4H729.8z" />
            <path class="st0" d="M765.6,93.4v71.3h-17.2V93.4H765.6z" />
            <path
                class="st0"
                d="M851.4,129.1c0,24.2-13.8,36.9-33.2,36.9c-19.3,0-33-12.7-33-36.9c0-24.3,13.7-37.1,33-37.1
		C837.6,92,851.4,104.8,851.4,129.1z M802.4,129.1c0,14.1,6.1,21.1,15.9,21.1c9.8,0,16.1-7,16.1-21.1s-6.3-21.2-16.1-21.2
		C808.5,107.9,802.4,115,802.4,129.1z"
            />
            <path class="st0" d="M885.4,93.4l24.3,39.4V93.4h17.1v71.3h-15.6l-25.9-39.3v39.3h-17.1V93.4H885.4z" />
            <path
                class="st0"
                d="M954.6,142.2c5.2,5,11.3,8.3,20.3,8.3c8.7,0,12.6-3,12.6-7.6c0-4.1-3-5.4-6.4-6.4c-4.6-1.3-13.1-3.1-20.2-5.9
		c-8.3-3.3-13.9-7.9-13.9-17.2c0-12.3,9.7-20.8,27.3-20.8c14.5,0,23.4,5.9,27.9,11.3l-12.1,10.4c-4.3-4.1-9.6-6.5-17-6.5
		c-5.8,0-9.7,1.4-9.7,4.8c0,2.9,2.7,4.1,5.4,5c5.8,2,14.2,3.2,20.7,5.7c7.8,3,14.5,8.3,14.5,19.4c0,14.9-12.3,22.7-30.3,22.7
		c-15.3,0-26-5.7-31.9-12.9L954.6,142.2z"
            />
        </g>
        <polygon
            class="st1"
            points="109.4,105.4 136.1,132.1 115.5,152.7 115.4,152.6 115.4,152.6 88.7,126 88.7,164.8 59.6,164.8 
	59.6,126 74.1,111.4 74.1,111.5 74.2,111.4 94.8,90.8 74.2,70.2 74.1,70.2 74.1,70.2 59.6,55.7 59.6,16.7 88.7,16.7 88.7,55.7 
	115.4,29 115.4,29 115.5,29 136.1,49.6 109.4,76.3 148.3,76.3 148.3,105.4 "
        />
        <polygon
            class="st0"
            points="94.7,90.8 74.1,111.4 59.6,126 32.9,152.6 12.3,132 38.9,105.4 0,105.4 0,76.3 38.9,76.3 12.3,49.6 
	32.9,29 59.6,55.7 74.1,70.2 74.2,70.3 "
        />
    </svg>
</template>

<style lang="postcss" scoped>
svg {
    @apply ml-4 w-[150px];

    @screen md {
        @apply w-[200px] ml-4;
    }
    .st0 {
        fill: #0a475a;
    }
    .st1 {
        fill: #a6dd72;
    }
}
</style>
